"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const discolorationskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-discolorationskin` : '') + (description ? ` desc-discolorationskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-discolorationskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-discolorationskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 20a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 17.5a.75.75 0 0 1 .69 1.04.75.75 0 0 1-.21 1.3c-.34.12-.71.2-1.1.26a8.89 8.89 0 0 1-3.6-.26.75.75 0 0 1 .5-1.42 4.55 4.55 0 0 0 1.25.24.74.74 0 0 1 .93.02l.7-.07.17-.02a.74.74 0 0 1 .67-1.1Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 18.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.25 16a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 16a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 15a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.25 13.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 13.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 12.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.25 11a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 11a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 10a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.25 8.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.26 8.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.26 7.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85.76A7.84 7.84 0 0 1 12.6.45c.64.19 1.22.5 1.66.95 2.72-.01 5 1 6.5 2.78 1.58 1.85 2.25 4.46 1.82 7.4-.35 2.51-1.03 4.99-2.74 6.85a7.7 7.7 0 0 1-1.8 2.97 7.82 7.82 0 0 1-12.66-2.02 10.84 10.84 0 0 1-4.09-8.36v-.53c.09-5.4 3.3-8.55 6.56-9.73Zm5.12 5.8c.02.06.03.12.03.19a.75.75 0 1 1-1.49-.15 6.34 6.34 0 0 0-5.41 6.27v2.87a6.32 6.32 0 0 0 5.6 6.5.75.75 0 1 1 1.1.03 6.32 6.32 0 0 0 2.77-.83.75.75 0 0 1 .67-.44 6.31 6.31 0 0 0 1.75-2.05.75.75 0 0 1 .54-1.4c.1-.4.17-.8.2-1.21a.75.75 0 1 1-.46-1.34c.17 0 .34.07.47.18l.02-1.37c-.13.12-.3.2-.5.2a.75.75 0 1 1 .51-1.3 6.33 6.33 0 0 0-.16-1.3.74.74 0 0 1-1.1-.66c0-.36.25-.66.59-.73a6.34 6.34 0 0 0-5.13-3.46Zm-.8-4.67a6.36 6.36 0 0 0-3.81.28c-2.74 1-5.5 3.63-5.57 8.35V11a9.34 9.34 0 0 0 1.82 5.44 7.86 7.86 0 0 1-.01-.72v-2.84a7.84 7.84 0 0 1 7.56-7.83 1.61 1.61 0 0 0 1.43-1.6 1.38 1.38 0 0 0-.3-.88c-.23-.29-.6-.52-1.12-.67Zm2.87 1.04a3.15 3.15 0 0 1-.58 2.37 7.84 7.84 0 0 1 5.82 7.57v.02l-.04 2.01a16 16 0 0 0 .86-3.53c.37-2.6-.23-4.75-1.48-6.22a6.51 6.51 0 0 0-4.58-2.22Z",
    fill: "#232323"
  }));
};
var _default = exports.default = discolorationskin;